import { Empty, PageHead, Panel, Pill } from '../components/ui';

type Plan = { title: string; sub: string; phase: string; ref: string; bullets: string[] };

const PLANS: Record<string, Plan> = {
  programs: {
    title: 'Programs & Initiatives', sub: 'Program elements, priority initiatives, controlling offices, primes and transition pathways',
    phase: 'Phase 1c', ref: 'NTN Requirements §1',
    bullets: [
      'Program element spine linked to budget line history, solicitations and organizations',
      'Priority initiative dashboards: Drone Dominance, IBAS, ME Commons, Golden Dome, DIU, OUSD(R&E), service labs',
      'Points of contact and prime contractors per program, sourced and dated',
    ],
  },
  analyst: {
    title: 'Digital Analyst', sub: 'Natural-language questions answered from the platform’s own data, with citations',
    phase: 'Phase 1d', ref: 'NTN Requirements §3',
    bullets: [
      'Retrieval over solicitations, budget history, profiles and notes; the LLM summarizes, it never invents a figure',
      'Every answer cites the rows it used, so a reader can click through to the source',
      'Document summarization for budget materials and solicitation attachments',
    ],
  },
  sources: {
    title: 'Data & Ingestion', sub: 'Every source, every run, every reconciliation number',
    phase: 'Phase 1b', ref: 'NTN Requirements §6',
    bullets: [
      'SAM.gov Opportunities API is live today; ingest runs record fetched, inserted, updated and unchanged counts',
      'Next: budget documents (PDF), Congress.gov, consortium and OTA member portals (needs approved credentials or exports)',
      'This page will show run history, source health and the last reconciliation per source',
    ],
  },
};

export function Placeholder({ id }: { id: string }) {
  const p = PLANS[id];
  if (!p) {
    return <><PageHead title="Not found" /><Empty>There is no page called “{id}”.</Empty></>;
  }
  return (
    <>
      <PageHead title={p.title} sub={p.sub} actions={<Pill kind="info">{p.phase}</Pill>} />
      <Panel title={`Planned scope · ${p.ref}`}>
        {p.bullets.map((b, i) => <div className="status-line" key={i}><span className="dot" style={{ background: 'var(--gold)', width: 6, height: 6, borderRadius: 3, flexShrink: 0 }} /><span>{b}</span></div>)}
        <div className="muted sm" style={{ marginTop: 14 }}>The data model for this module is already in the database (see db/migrations). The screens and ingestion arrive in the phase shown above.</div>
      </Panel>
    </>
  );
}
